import React from "react";
import { connect } from "react-redux";
import {
  mediaSelected,
  selectAll,
} from "browse-media/redux/browseMediaActions";
import scrollToTop from "components/scrollToTop";
import { Checkbox } from "react-toolbox/lib/checkbox";
import { List } from "react-toolbox/lib/list";
import BrowseMediaSearchResultsPager from "browse-media/components/BrowseMediaSearchResultsPager";
import BrowseMediaSearchResultsRow from "browse-media/components/BrowseMediaSearchResultsRow";
import styles from "browse-media/components/BrowseMediaSearchResultsTable.css";

const ScrollToContainer = scrollToTop(({ children, searching, ...props }) => (
  <div {...props}>{children}</div>
));

const BrowseMediaSearchResultsTable = ({
  allSelected,
  mediaList,
  onRowSelect,
  onSelectAll,
  searching,
  selectedMediaIds,
  totalCount,
}) => (
  <div className={styles.container}>
    <div className={styles.tableHeader}>
      <Checkbox
        theme={styles}
        onChange={onSelectAll}
        checked={allSelected}
        disabled={totalCount < 1}
      />
      <h3 className={styles.titleColumnHeader}>Media</h3>
      <h3 className={styles.modulesColumnHeader}>Modules</h3>
      <h3 className={styles.actionColumnHeader} />
    </div>
    <ScrollToContainer
      className={styles.tableBody}
      searching={searching}
      scrollTopProp="searching"
      scrollTopPropValue={false}
    >
      <List theme={styles}>
        {mediaList.map(media => (
          <BrowseMediaSearchResultsRow
            key={media.id}
            media={media}
            selected={selectedMediaIds.includes(media.id)}
            onSelect={onRowSelect}
          />
        ))}
      </List>
      <BrowseMediaSearchResultsPager />
    </ScrollToContainer>
  </div>
);

const mapStateToProps = state => {
  const {
    mediaList,
    searching,
    selectedMediaIds,
    totalCount,
  } = state.browseMedia;

  return {
    allSelected:
      mediaList.length > 0 && mediaList.length === selectedMediaIds.length,
    mediaList,
    searching,
    selectedMediaIds,
    totalCount,
  };
};

const mapDispatchToProps = dispatch => ({
  onRowSelect: (selected, mediaId) =>
    dispatch(mediaSelected(selected, mediaId)),
  onSelectAll: selected => dispatch(selectAll(selected)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrowseMediaSearchResultsTable);
